namespace TabAurous.Inventory {
    export namespace OpeningStockItemsService {
        export const baseUrl = 'OpeningStock/OpeningStockItems';

        export declare function Create(request: Serenity.SaveRequest<OpeningStockItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OpeningStockItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OpeningStockItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OpeningStockItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<OpeningStockItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetItemDetails(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<OpeningStockItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OpeningStock/OpeningStockItems/Create",
            Update = "OpeningStock/OpeningStockItems/Update",
            Delete = "OpeningStock/OpeningStockItems/Delete",
            Retrieve = "OpeningStock/OpeningStockItems/Retrieve",
            List = "OpeningStock/OpeningStockItems/List",
            CustomList = "OpeningStock/OpeningStockItems/CustomList",
            GetItemDetails = "OpeningStock/OpeningStockItems/GetItemDetails"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'GetItemDetails'
        ].forEach(x => {
            (<any>OpeningStockItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
